export const BATTLE_TYPE = {
  RSP: 'rockSiccersPaper',
} as const;

export type BATTLE_TYPE_KEY = keyof typeof BATTLE_TYPE;

export type BATTLE_TYPE_VALUE = typeof BATTLE_TYPE[BATTLE_TYPE_KEY];

export const BATTLE_TYPE_MAP = {
  [BATTLE_TYPE.RSP]: '가위 바위 보',
};

export const selectedAccessList = [
  {
    key: BATTLE_TYPE.RSP,
    value: BATTLE_TYPE_MAP[BATTLE_TYPE.RSP],
  },
];

export const BATTLE_MODE = {
  INSTANT: 'instant',
  CHALLENGE: 'challenge',
} as const;

export type BATTLE_MODE_KEY = keyof typeof BATTLE_MODE;
export type BATTLE_MODE_VALUE = typeof BATTLE_MODE[BATTLE_MODE_KEY];

export const BATTLE_MODE_MAP = {
  [BATTLE_MODE.INSTANT]: '즉시 결과',
  [BATTLE_MODE.CHALLENGE]: '도전장 보내기',
} as const;
